import React, { useState } from 'react';

import {
    TextField,
    Button,
    IconButton,
    Typography,
    Box,
    Modal,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import RadioBoxGroup from '../../components/RadioButtons/RadioBoxGroup'

const modalMoveActivities = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    maxWidth: '586px',
    width: '90%',
    margin: 'auto',
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: '2px',
    // border: '2px solid #0B57D0'
    border: '2px solid transparent',
    backgroundImage: 'linear-gradient(white, white), linear-gradient(136deg, rgba(0, 170, 231, 1), rgba(89, 50, 234, 1))',
    backgroundOrigin: 'border-box',
    backgroundClip: 'content-box, border-box',
    borderRadius: '12px',
};

const ToggleConfirm = ({ open, onClose }) => {
    return (
        <Modal open={open} onClose={onClose} fullWidth maxWidth="sm">
            <Box sx={{
                ...modalMoveActivities,
                display: 'flex',
                flexDirection: 'column',
                maxHeight: '90vh',
                overflow: 'hidden',
            }}>
                {/* Header */}
                <Box display="flex" justifyContent="space-between" alignItems="center" sx={{ p: '20px', borderBottom: '1px solid #e0e0e0', position: 'sticky', top: 0, zIndex: 1, backgroundColor: '#fff', borderRadius: '12px 12px 0 0' }}>
                    <Typography variant="h6" fontSize={'22px'} fontWeight={'700'} sx={{ lineHeight: '1', fontFamily: 'Manrope' }}>Confirm changes</Typography>
                    <IconButton onClick={onClose} className='p-0'>
                        <CloseIcon sx={{ fontSize: '20px', color: '#000' }} />
                    </IconButton>
                </Box>
                {/* End Header */}

                {/* start Body sec  */}
                <Box sx={{ flex: 1, overflowY: 'auto', px: '22px', py: '26px' }} dividers>
                    <Box sx={{ m: '0 auto 24px' }}>
                        <Typography sx={{ fontSize: '22px', color: '#1A1F36', fontFamily: 'Manrope', fontWeight: '700' }}>Allow Team leads to manage projects</Typography>
                        <Typography color='#64748B' mb={0} sx={{ fontSize: '12px', fontWeight: '400', fontFamily: 'Manrope', color: '#64748B' }}>
                            Turning ON this global setting will allow Team leads to manage projects that their teams are assigned. Apply this change to:
                        </Typography>
                    </Box>









                    <Box display="flex" alignItems="flex-start" sx={{ gap: '2', border: '1px solid #0076FE', borderRadius: '8px', p: '18px', margin:'0 auto 16px'  }}>
                        <RadioBoxGroup
                            options={['']}
                            defaultValue="Everyone"
                            row={true}
                        />
                        <Box>
                            <Typography sx={{ fontSize: '16px', fontWeight: '600', fontFamily: 'Manrope', color: '#1A1F36', lineHeight: 1 }}>Team leads on all projects</Typography>
                            <Typography sx={{ fontSize: '14px', fontWeight: '400', fontFamily: 'Manrope', color: '#8C8C8C' }}>Team leads, including those already assigned to existing projects will be able to manage projects.</Typography>
                        </Box>
                    </Box>
                    <Box display="flex" alignItems="flex-start" sx={{ gap: '2', border: '1px solid #0076FE', borderRadius: '8px', p: '18px',}}>
                        <RadioBoxGroup
                          options={['']}
                            defaultValue="Everyone"
                            row={true}
                        />
                        <Box>
                            <Typography sx={{ fontSize: '16px', fontWeight: '600', fontFamily: 'Manrope', color: '#1A1F36', lineHeight: 1 }}>Teams leads assigned to future projects</Typography>
                            <Typography sx={{ fontSize: '14px', fontWeight: '400', fontFamily: 'Manrope', color: '#8C8C8C' }}>Team leads assigned to future projects will be able to manage projects. This won't change existing Team lead roles on projects they are already assigned and this can be changed later on individual Team lead profiles.</Typography>
                        </Box>
                    </Box>

                </Box>
                {/* End Body sec  */}

                {/* start Footer sec  */}
                <Box sx={{ p: '20px 30px', borderTop: '1px solid #e0e0e0', position: 'sticky', bottom: 0, backgroundColor: '#F2F6F9', display: 'flex', justifyContent: 'space-between', gap: 2, borderRadius: '0 0 12px 12px' }}>

                    <Button onClick={onClose} variant="outlined" className='bg-white text-capitalize' color="#1A1F36" sx={{ p: '14px 22px', fontSize: '16px', fontWeight: '500', height: '50px', border: '1px solid #D9D9D9', fontFamily: 'Manrope' }}>
                        Cancel
                    </Button>
                    <Button variant="contained" color="primary" className='text-capitalize' sx={{ boxShadow: 'unset', backgroundColor: '#0B57D0', p: '14px 22px', fontSize: '16px', fontWeight: '500', height: '50px', border: '1px solid #0B57D0', fontFamily: 'Manrope' }}>
                        Confrim
                    </Button>

                </Box>
                {/* End Footer sec  */}
            </Box>
        </Modal>
    );
};
export default ToggleConfirm;
